
import { menu, Item_Option, Item_li } from "../fable_modules/Fulma.3.0.0/Components/Menu.fs.js";
import { CSSProp, HTMLAttr, DOMAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { truncate, zip, tail, cons, tryHead, fold, length, reverse, map as map_1, collect as collect_1, append as append_1, empty, singleton, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { map as map_2, empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import * as react_1 from "react";
import { updateProjectFromCanvas } from "./MenuHelpers.js";
import { DrawModelType_SheetT_Model__Model_GetCanvasState } from "../DrawBlock/Sheet.js";
import { startCircuitSimulation } from "../Simulator/Simulator.js";
import { error, warn } from "../Shared/Log.js";
import { join, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { errMsg } from "../Simulator/SimGraphTypes.js";
import { Msg, RightTab } from "../Model/ModelType.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { writeFile, tryCreateFolder, pathJoin } from "../Interface/FilesIO.js";
import { CompilationProfile, VMode, getVerilog } from "../VerilogComponent/Verilog.js";
import { item, map, collect } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { DrawModelType_SheetT_DebugState, DrawModelType_SheetT_Msg } from "../Model/DrawModelType.js";
import { displayAlertOnError } from "./Notifications.js";
import { Color_IColor, Common_GenericOption } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { label as label_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { select } from "../fable_modules/Fulma.3.0.0/Elements/Form/Select.fs.js";
import { TableOption, table } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { min } from "../fable_modules/fable-library-js.5.13.0/Double.js";

function menuItem(styles, label, onClick) {
    return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* Props */ 1, [ofArray([new DOMAttr(/* OnClick */ 40, [onClick]), ["style", keyValueList(styles, 1)]])])]), singleton(label));
}

function makeRowForCompilationStage(name, stage) {
    const minutesSeconds = (t) => {
        const seconds = (t % 60) | 0;
        return `${~~(t / 60)}:${(seconds < 10) ? "0" : ""}${seconds}`;
    };
    const children_10 = toList(delay(() => append(singleton_1(react_1.createElement("th", {}, name)), delay(() => {
        let props_4, children_4, props_6, props_8, props_2, children_2;
        const matchValue = stage;
        return (matchValue.tag === 1) ? singleton_1((props_4 = [["style", {
            backgroundColor: "yellow",
        }]], (children_4 = [minutesSeconds(matchValue.fields[0])], react_1.createElement("th", keyValueList(props_4, 1), ...children_4)))) : ((matchValue.tag === 2) ? singleton_1((props_6 = [["style", {
            backgroundColor: "red",
        }]], react_1.createElement("th", keyValueList(props_6, 1), "XX"))) : ((matchValue.tag === 3) ? singleton_1((props_8 = [["style", {
            backgroundColor: "gray",
        }]], react_1.createElement("th", keyValueList(props_8, 1), "--"))) : singleton_1((props_2 = [["style", {
            backgroundColor: "green",
        }]], (children_2 = [minutesSeconds(matchValue.fields[0])], react_1.createElement("th", keyValueList(props_2, 1), ...children_2))))));
    }))));
    return react_1.createElement("tr", {}, ...children_10);
}

export function verilogOutput(vType, profile, model, dispatch) {
    let tupledArg;
    const matchValue = updateProjectFromCanvas(model, dispatch);
    const matchValue_1 = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    if (matchValue != null) {
        const state = matchValue_1;
        const proj = matchValue;
        if (model.UIState == null) {
            const matchValue_4 = startCircuitSimulation(2, proj.OpenFileName, state[0], state[1], proj.LoadedComponents);
            if (matchValue_4.tag === 1) {
                const simError = matchValue_4.fields[0];
                warn(concat("simulation error prevents Verilog output: ", errMsg(simError.ErrType)));
                dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Simulation]));
                if (simError.InDependency == null) {
                    dispatch((tupledArg = [simError.ComponentsAffected, simError.ConnectionsAffected], new Msg(/* SetHighlighted */ 35, [tupledArg[0], tupledArg[1]])));
                }
                dispatch(new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Error */ 1, [simError])]));
            }
            else {
                const sim = matchValue_4.fields[0];
                const path = pathJoin([proj.ProjectPath, proj.OpenFileName + ".v"]);
                tryCreateFolder(pathJoin([proj.ProjectPath, "/build"]));
                let _arg_1;
                try {
                    const verilog = getVerilog(vType, sim.FastSim, profile);
                    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* DebugUpdateMapping */ 56, [collect((_arg) => {
                        if (_arg[1] === 0) {
                            return [];
                        }
                        else {
                            return map((i) => _arg[0], Int32Array.from(rangeDouble(0, 1, _arg[1] - 1)));
                        }
                    }, map((fc_1) => [fc_1.FullName, item(0, fc_1.Outputs).Width], sim.FastSim.FOrderedComps.filter((fc) => {
                        if (fc.FType.tag === 2) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    })))])]));
                    _arg_1 = writeFile(path, verilog);
                }
                catch (e) {
                    error(concat("generating Verilog output: ", e.message));
                    _arg_1 = (new FSharpResult$2(/* Error */ 1, [e.message]));
                }
                if (_arg_1.tag === 1) {
                    displayAlertOnError(dispatch, new FSharpResult$2(/* Error */ 1, [_arg_1.fields[0]]));
                }
                else {
                    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* StartCompiling */ 45, [proj.ProjectPath, proj.OpenFileName, profile])]));
                }
            }
        }
    }
}

export function viewBuild(model, dispatch) {
    const model_1 = model;
    return menu(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new HTMLAttr(/* Class */ 65, ["py-1"]), ["style", keyValueList((model_1.Sheet.Action.tag === 13) ? singleton(new CSSProp(/* Cursor */ 123, ["grabbing"])) : empty(), 1)]])])), toList(delay(() => append(model_1.Sheet.Compiling ? singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsDanger]), new Option(/* OnClick */ 18, [(_arg) => {
        dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.StopCompilation]));
    }])]), singleton("Stop building"))) : append(singleton_1(label_1(empty(), singleton("Device Selection"))), delay(() => {
        let children_10;
        return append(singleton_1(label_1(empty(), singleton(select(empty(), singleton((children_10 = append_1(singleton(react_1.createElement("option", {
            value: "",
            selected: true,
            disabled: true,
        }, "Select Device")), append_1(singleton(react_1.createElement("option", {
            value: "IceStick",
        }, "IceStick")), append_1(singleton(react_1.createElement("option", {
            value: "IssieStick-v0.1",
        }, "IssieStick v0.1")), singleton(react_1.createElement("option", {
            value: "IssieStick-v1.0",
        }, "IssieStick v1.0"))))), react_1.createElement("select", {
            onChange: (option) => {
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* SetDebugDevice */ 59, [option.target.value])]));
            },
        }, ...children_10))))))), delay(() => append(singleton_1(react_1.createElement("br", {})), delay(() => {
            const isDisabled = model_1.Sheet.DebugDevice == null;
            return append(singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* Disabled */ 16, [isDisabled]), new Option(/* OnClick */ 18, [(_arg_1) => {
                dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_1) => {
                    verilogOutput(VMode.ForSynthesis, CompilationProfile.Release, model_2, dispatch_1);
                }, dispatch]));
            }])]), singleton("Build and upload"))), delay(() => singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* Disabled */ 16, [isDisabled]), new Option(/* OnClick */ 18, [(_arg_2) => {
                dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_3, dispatch_2) => {
                    verilogOutput(VMode.ForSynthesis, CompilationProfile.Debug, model_3, dispatch_2);
                }, dispatch]));
            }])]), singleton("Build and Debug")))));
        }))));
    })), delay(() => append(singleton_1(react_1.createElement("br", {})), delay(() => append(singleton_1(react_1.createElement("br", {})), delay(() => {
        let children_18, children_16, children_20;
        return append(singleton_1(table(ofArray([TableOption.IsFullWidth, TableOption.IsBordered]), ofArray([(children_18 = [(children_16 = [react_1.createElement("th", {}, "Stage"), react_1.createElement("th", {}, "Progress")], react_1.createElement("tr", {}, ...children_16))], react_1.createElement("thead", {}, ...children_18)), (children_20 = [makeRowForCompilationStage("Synthesis", model_1.Sheet.CompilationStatus.Synthesis), makeRowForCompilationStage("Place And Route", model_1.Sheet.CompilationStatus.PlaceAndRoute), makeRowForCompilationStage("Generate", model_1.Sheet.CompilationStatus.Generate), makeRowForCompilationStage("Upload", model_1.Sheet.CompilationStatus.Upload)], react_1.createElement("tbody", {}, ...children_20))]))), delay(() => append(equals(model_1.Sheet.DebugState, DrawModelType_SheetT_DebugState.Paused) ? append(singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_3) => {
            dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DebugSingleStep]));
        }])]), singleton("Step"))), delay(() => singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_4) => {
            dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DebugContinue]));
        }])]), singleton("Continue"))))) : (equals(model_1.Sheet.DebugState, DrawModelType_SheetT_DebugState.Running) ? singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_5) => {
            dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DebugPause]));
        }])]), singleton("Pause"))) : empty_1()), delay(() => (!equals(model_1.Sheet.DebugState, DrawModelType_SheetT_DebugState.NotDebugging) ? append(singleton_1(react_1.createElement("br", {})), delay(() => append(singleton_1(react_1.createElement("br", {})), delay(() => {
            let children_28, children_26, props_32, props_34, children_36, mappings, bits_1, paired;
            return singleton_1(table(ofArray([TableOption.IsFullWidth, TableOption.IsBordered]), ofArray([(children_28 = [(children_26 = [(props_32 = [["style", {
                backgroundColor: "lightgray",
            }]], react_1.createElement("th", keyValueList(props_32, 1), "Viewer")), (props_34 = [["style", {
                backgroundColor: "lightgray",
            }]], react_1.createElement("th", keyValueList(props_34, 1), "Value"))], react_1.createElement("tr", {}, ...children_26))], react_1.createElement("thead", {}, ...children_28)), (children_36 = ((mappings = ofArray(model_1.Sheet.DebugMappings), (bits_1 = append_1(collect_1((byte) => map_1((i) => (~~(byte / Math.pow(2, i)) % 2), reverse(toList(rangeDouble(0, 1, 7)))), model_1.Sheet.DebugData), map_1((_arg_6) => undefined, toList(rangeDouble(1, 1, 256)))), map_1((tupledArg_1) => {
                let children_30, children_32;
                const bits_4 = tupledArg_1[1];
                const children_34 = [(children_30 = [tupledArg_1[0] + ((length(bits_4) === 1) ? "" : (`[${length(bits_4) - 1}:0]`))], react_1.createElement("th", {}, ...children_30)), (children_32 = ["0b" + join("", map_1((nOpt) => {
                    let option_1, copyOfStruct;
                    const str = defaultArg((option_1 = nOpt, (option_1 != null) ? ((copyOfStruct = option_1, toString(copyOfStruct))) : undefined), "x");
                    return Array.from(map_2((ch) => {
                        if (model_1.Sheet.DebugIsConnected) {
                            return ch;
                        }
                        else {
                            return "X";
                        }
                    }, str.split(""))).join('');
                }, bits_4))], react_1.createElement("th", {}, ...children_32))];
                return react_1.createElement("tr", {}, ...children_34);
            }, (paired = (min(length(mappings), length(bits_1)) | 0), fold((s_15, tupledArg) => {
                const name_1 = tupledArg[0];
                const bit = tupledArg[1];
                const matchValue_2 = tryHead(s_15);
                let matchResult, bits_3, n_1;
                if (matchValue_2 != null) {
                    if ((matchValue_2[1], matchValue_2[0] === name_1)) {
                        matchResult = 0;
                        bits_3 = matchValue_2[1];
                        n_1 = matchValue_2[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return cons([n_1, cons(bit, bits_3)], tail(s_15));
                    default:
                        return cons([name_1, singleton(bit)], s_15);
                }
            }, empty(), zip(truncate(paired, mappings), truncate(paired, bits_1)))))))), react_1.createElement("tbody", {}, ...children_36))])));
        })))) : empty_1())))));
    })))))))));
}

